<mobi-product-layout [entity]="entity()" [hasOverview]="false" />
